import axios from 'axios';
import { cachetime } from '../config';

export default function() {
  return {
    namespaced: true,
    state: {
      enfs: {},
      __updatedAt: {},
    },
    mutations: {
      SET_ENF(state, { data, locale}) {
        state.enfs = {
          ...state.enfs,
          [locale]: data,
        }
        state.__updatedAt[locale] = Date.now();
      },
    },
    actions: {
      FETCH_UPCOMING_EVENT({ state, commit }, { locale }) {
        if (state.enfs[locale]
          && state.__updatedAt[locale]
          && Date.now() - state.__updatedAt[locale] < cachetime 
        ) return ;

        return axios.get(encodeURI(`/api/enf`))
          .then((res) => {
            const data = res.data || {};
            const { enfs=[] } = data;

            commit('SET_ENF', { data: enfs, locale });
          }).catch(err => console.log(err));      
      },
    },
    getters: { 
      getEnfs: (state) => (locale) => {
        return state.enfs[locale] 
          || new Array(4).fill().map((val, idx) => ({ 
            value: idx,
            thumbnail: '',
            name: ''
          }));;;
      }
    }
  }
}